import { useEffect, useState } from "react";
import { isFinePointer } from "../utils/motion";

const useFinePointer = () => {
  const [finePointer, setFinePointer] = useState(isFinePointer);

  useEffect(() => {
    if (!window.matchMedia) return undefined;

    const mediaQuery = window.matchMedia("(hover: hover) and (pointer: fine)");
    const handleChange = () => setFinePointer(mediaQuery.matches);

    handleChange();
    mediaQuery.addEventListener("change", handleChange);

    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return finePointer;
};

export default useFinePointer;
